import type { Components, Theme } from "@mui/material";

export const MuiLink: Components<Theme>["MuiLink"] = {
	defaultProps: {
		variant: "body1",
		color: "primary",
	},
	variants: [
		{
			props: {},
			style: {
				borderBottomStyle: "solid",
				borderBottomWidth: 1,
				fontWeight: "inherit",
				lineHeight: 1.25,
				textDecoration: "none",
			},
		},
		{
			props: { color: "primary" },
			style: ({ theme }) => ({
				borderColor: "inherit",
				color: theme.palette.text.primary,
				"&:hover": {
					color: theme.palette.primary.main,
				},
			}),
		},
	],
};
